module.exports = __webpack_public_path__ + "img/2.2fcd00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = UT21
// module chunks = 1